import { makeStyles } from "@material-ui/core";

export const useUserViewStyles = makeStyles((theme) => ({
  userName: {
    fontSize: 18,
    color: "black",
  },
}));
